<template>
    <div class="user-menu__avatar" :style="`background: url(${url + image}) center/cover no-repeat; width: 80px; height: 80px;`">
    </div>
</template>

<script>
import {mapState} from 'vuex';
export default {
  computed: {
    ...mapState('common', [
      'url',
    ]),
  },
  props: {
    image: {
      type: String,
    },
  },
};
</script>
